import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const BrandingContext = createContext({
  siteName: 'FTNS+ Partner',
  bannerImageUrl: '',
  loginLogoUrl: '',
  loginTitle: '',
  loginSubtitle: '',
  partnerSiteName: '',
  partnerLoginSubtitle: '',
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(BrandingContext._currentValue);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/branding');
        if (!cancelled && res.data?.success && res.data.data) {
          setBranding((prev) => ({ ...prev, ...res.data.data }));
        }
      } catch {
        // keep defaults
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

